<template>
<button class="show-alert-btn" @click="showAlert">Show Alert</button>

    <div :class="['top-alert', 'success', successAlert ? 'show' : '']">
      <strong>Thank you</strong> for providing your requirement. Your response has been submitted successfully.
    </div>

    <div :class="['top-alert', 'error', errorAlert ? 'show' : '']">
      Please fill all the required fields!
    </div>

  <div>
    <!-- Contact Button -->
    <!-- <button @click="openSidebar" class="contact-btn">Contact</button> -->

    <!-- Overlay -->
    <div
      class="overlay"
      :class="{ show: isOpen }"
      @click="closeSidebar">
    </div>

    <!-- Sidebar -->
    <div class="sidebarContactForm" :class="{ open: isOpen }">
      <div class="formCard">
        <h4 style="font-family: 'Zoho_Puvi_Bold' !important;">Get in Touch</h4>

        <p>
          Find out the form below to schedule a call with us.
          Our curated experts are here to help you out with your
          organization’s needs!
        </p>
        <a class="close-btn" @click="closeSidebar">×</a>
      </div>

      <div class="form-body" style="height: 72vh; overflow: auto; padding-bottom: 100px;">
        <h3 style="font-family: 'Zoho_Puvi_Bold' !important;">Enter Details</h3>

        <div class="form-group">
          <label>Full Name <span>*</span></label>
          <input
            type="text"
            placeholder="Enter your name"
            v-model="getInTouchFormData.FullName"
            @change="updateGetInTouchData($event.target.value, 'FullName')"
        />
        </div>

        <!-- <div class="form-group">
          <label>Email Address <span>*</span></label>
          <input
            type="email"
            placeholder="Enter your Email address"
            v-model="getInTouchFormData.Email"
            @change="updateGetInTouchData($event.target.value, 'Email')"
        />
        </div> -->

        <div class="form-group">
          <label>Select Industry <span>*</span></label>
          <select
            class="custom-select"
            v-model="getInTouchFormData.Industry"
            @change="updateGetInTouchData($event.target.value, 'Industry')"
        >
            <option value="" disabled>Choose industry</option>
            <option v-for="industry in getIndustries">{{ industry.INDUSTRIES.Industry }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Your Requirements</label>
          <textarea
            placeholder="Enter your requirements"
            v-model="getInTouchFormData.YourRequirements"
            @change="updateGetInTouchData($event.target.value, 'YourRequirements')"
          ></textarea>
        </div>

        <button class="submit-btn" @click="submitForm">
            <!-- <div class="submit-loader"></div> -->
            Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: "ContactSidebar",

  data() {
    return {
      isOpen: false,
      formSubmitting: false,
      successAlert: false,
      errorAlert: false,
      form: {
        name: "",
        email: "",

        industry: "",
        requirements: ""
      }
    };
  },

  computed: {
    ...mapState(["getInTouchFormData", "getIndustries", "loginUserDetails"])
  },

  mounted() {
    setTimeout(() => {
        this.isOpen = true;

        // console.log("Login User Details", this.loginUserDetails);

        if (this.loginUserDetails.userName) {
          this.updateGetInTouchData(this.loginUserDetails.userName, 'FullName')
        }
        if (this.loginUserDetails.userEmail) {
          this.updateGetInTouchData(this.loginUserDetails.userEmail, 'Email')
        }
    }, 100);

    // console.log("Gt in touch data: ", this.getInTouchFormData);

  },

  methods: {
    ...mapActions(["addNewLead"]),

    showSuccess() {
      this.successAlert = true;
      setTimeout(() => (this.successAlert = false), 1900);
    },

    showError() {
      this.errorAlert = true;
      setTimeout(() => (this.errorAlert = false), 3000);
    },

    openSidebar() {
      this.isOpen = true;
    },

    closeSidebar() {
      this.isOpen = false;
      setTimeout(() => {
          this.$emit('closeForm', true);
      }, 100)
    },


    updateGetInTouchData(value, field) {
        // console.log(value);

        let getInTouchData = this.getInTouchFormData;
        getInTouchData[field] = value;
        this.$store.commit('setGetInTouchFormData', getInTouchData);

        // console.log("Updated Data: ", this.getInTouchFormData);
    },

    async submitForm() {
        if (!this.formSubmitting) {

            //   console.log("Submitted Data:", this.getInTouchFormData);
                if (this.getInTouchFormData.FullName && this.getInTouchFormData.Email && this.getInTouchFormData.Industry) {
                    this.formSubmitting = true;
                    try {
                        await this.addNewLead();
                        this.showSuccess();
                        setTimeout(() => {
                            this.getInTouchFormData.FullName = "";
                            this.getInTouchFormData.Email = "";
                            this.getInTouchFormData.Industry = "";
                            this.getInTouchFormData.YourRequirements = "";

                            // this.updateGetInTouchData("", 'FullName')
                            // this.updateGetInTouchData("", 'Email')
                            // this.updateGetInTouchData("", 'Industry')
                            this.closeSidebar();
                        }, 2100)
                    } catch (e) {
                        // console.log(e);
                    }
                } else {
                    this.showError()
                }
        }
    }
  }
};
</script>

<style src="../../assets/css/contact.css">

</style>

<style scoped>

::-webkit-scrollbar {
  display: none;
}

.submit-loader {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/* Buttons */
.btn {
  padding: 10px 18px;
  margin-right: 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: white;
  font-size: 15px;
}
.success-btn {
  background: #16a34a;
}
.error-btn {
  background: #dc2626;
}

/* Base Alert Style */
.top-alert {
  position: fixed;
  top: -80px; /* hidden above */
  left: 50%;
  transform: translateX(-50%);
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 15px;
  color: white;
  box-shadow: 0px 4px 20px rgba(0,0,0,0.15);
  z-index: 99999;
  transition: top 0.4s ease;
  min-width: 250px;
  text-align: center;
}

/* Show Animation */
.top-alert.show {
  top: 20px;
}

/* Colors */
.top-alert.success {
  background: #16a34a;
}

.top-alert.error {
  background: #dc2626;
}
</style>
